export default __webpack_public_path__ + "static/media/instant_advent_light.b9795e65.png";